/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.31",
    versionName: "0.2.0-nightly.2025.7.31",
    versionChannel: "nightly",
    buildDate: "2025-07-31T00:08:04.498Z",
    commitHash: "4350a810d5cf3691c555be92f126fbe589ad93ee",
};
